/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-mobile': {
    width: 6,
    height: 9,
    viewBox: '0 0 6 9',
    data: '<path pid="0" d="M1.222 6.7H5.04V2.01H1.222V6.7zm3.436 2H1.604a.782.782 0 0 1-.782-.782V1.082c0-.432.35-.782.782-.782h3.054c.432 0 .782.35.782.782v6.836c0 .432-.35.782-.782.782zm-.86-7.679H2.464a.133.133 0 0 0 0 .267h1.334a.133.133 0 0 0 0-.267zM2.63 7.637a.501.501 0 1 0 1.002 0 .501.501 0 0 0-1.002 0z" _fill="#000" fill-rule="nonzero"/>'
  }
})
